import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'prof-copyright',
    templateUrl: './copyright.component.html',
    styleUrls: ['./copyright.component.scss'],
    standalone: false
})
export class CopyrightComponent implements OnInit {
  public year: number;

  constructor() {}

  ngOnInit() {
    this.year = new Date().getFullYear();
  }
}
